// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module--spinner--V7X59","spinner-border":"Spinner-module--spinner-border--3xa67","small":"Spinner-module--small--bZ5p8"};